import { ClassNameValue, twMerge } from 'tailwind-merge'

export const isProduction = (process.env.NEXT_PUBLIC_ENV || process.env.SERVER_ENV) === 'production'
export const isDevelopment =
  (process.env.NEXT_PUBLIC_ENV || process.env.SERVER_ENV || process.env.NODE_ENV || 'development') === 'development'
export const isTestMode = process.env.NEXT_PUBLIC_TEST_MODE === 'true' || process.env.TEST_MODE === 'true'

export const htRandom = () => {
  if (process.env.TEST_MODE === 'true' || process.env.NEXT_PUBLIC_TEST_MODE === 'true') {
    return 0
  }
  return Math.random()
}

const isLocalStorageAvailable = () => {
  try {
    if (typeof window === 'undefined') {
      return false
    }
    if (typeof window.localStorage === 'undefined') {
      return false
    }
    window.localStorage.setItem('__test', 'yes')
    window.localStorage.removeItem('__test')
    return true
  } catch {
    return false
  }
}

export { isLocalStorageAvailable }
export { formatSecondsToTime } from './time-utils'
export { formatPrice } from './format-price'

export const scrollToAnchorWithOffset = (id: string, _offset?: number) => {
  const target = document.getElementById(id) as HTMLElement
  if (!target) return
  // Use scrollIntoView to avoid forced reflows from reading offsetTop
  // The offset parameter is kept for backwards compatibility but no longer used
  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export function parameterize(str: string) {
  return str
    .normalize('NFKD') // split accented letters
    .replace(/[\u0300-\u036f]/g, '') // remove diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // non-alphanumeric to hyphen
    .replace(/^-+|-+$/g, '') // trim hyphens
    .replace(/-+/g, '-') // collapse hyphens
}

export function sortStringObjectByKeys(obj: Record<string, string>) {
  return Object.keys(obj)
    .sort((a, b) => a.localeCompare(b))
    .reduce<Record<string, string>>((acc, key) => {
      acc[key] = obj[key]
      return acc
    }, {})
}

export const isDev =
  typeof window !== 'undefined' ? window.location.hostname === 'localhost' : process.env.NODE_ENV === 'development'

// turns logic within className into a string to make sure no 'undefined' etc. show up in the DOM
export const cx = (...classes: (string | false | undefined | null)[]) => classes.filter(Boolean).join(' ')
export const tw = (...classes: (string | undefined | null | boolean | ClassNameValue)[]) =>
  twMerge(classes.filter(Boolean).join(' '))
